import { render, staticRenderFns } from "./CfDetail.vue?vue&type=template&id=585f9959"
import script from "./CfDetail.vue?vue&type=script&lang=ts"
export * from "./CfDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports